import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Descriptions, Modal, Row, Table } from "antd";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import FormInput from "../../component/FormInput";
import {
  INPUT_TYPE,
  lang,
  MODE_SCREEN,
  REGEX_INPUT,
} from "../../constants/common.const";
import "./index.scss";
import { formatDecimal, formatNumberFloat } from "../../utils/helper";
function PlanValudeInformation({
  mode,
  overallPlanGrid,
  bussinessPlanGrid,
  listViewOverrall,
  listViewBussiness,
  handlechangeInputPlanOverral,
  handlechangeInputPlanBussiness,
  onSelectData,
  currentOverall,
  currentBussiness,
  listSelectOverall = [],
  setListSelectOverall,
  listSelectBussiness = [],
  setListSelectBussiness,
  inputRefs,
  disabled,
}) {
  const renderFormatInput = (value) => formatNumberFloat(value);
  const renderFormatInputDecimal = (value, decimal) =>
    formatNumberFloat(decimal ? formatDecimal(value, decimal) : value);

  const initColumns = [
    {
      title: "No",
      dataIndex: "No",
      align: "center",
      width: "1%",
      filter: false,
    },
    {
      title: "比較",
      dataIndex: "comparison",
      required: true,
      align: "center",
      render: (_, record) => (
        <Checkbox
          disabled={disabled}
          checked={listSelectOverall.includes(record.id)}
          onChange={(e) => {
            const value = e.target.checked;
            const bussinessItem = bussinessPlanGrid.data.find(
              (i) => i.planningFormulationYear == record.planningFormulationYear
            );
            if (value) {
              setListSelectOverall([...listSelectOverall, record.id]);
              if (bussinessItem) {
                setListSelectBussiness([
                  ...listSelectBussiness,
                  bussinessItem.id,
                ]);
              }
            } else {
              setListSelectOverall(
                [...listSelectOverall].filter((i) => i != record.id)
              );
              if (bussinessItem) {
                setListSelectBussiness(
                  [...listSelectBussiness].filter((i) => i != bussinessItem.id)
                );
              }
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      ),
      width: "1%",
    },
    {
      title: "計画策定年度",
      dataIndex: "planningFormulationYear",
      width: "3%",
      align: "center",
    },
    {
      title: "計画目標年度",
      dataIndex: "plannedTargetYear",
      width: "3%",
      align: "center",
    },
    {
      title: "計画汚水量(m3/日)",
      width: "4%",
      dataIndex: "plannedSewageVolume",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画処理能力(m3/日)",
      width: "4%",
      dataIndex: "plannedMaxDailyTreatmentCap",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "処理区域面積 (ha)",
      width: "3%",
      dataIndex: "treatmentAreaSize",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画処理人口",
      dataIndex: "plannedTreatmentPopulation",
      width: "3%",
      align: "right",
      render: renderFormatInput,
    },
    {
      title: "計画流入水質 BOD(mg/l)",
      dataIndex: "plannedInfluentWaterQualityBOD",
      width: "4%",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画流入水質 SS(mg/l)",
      dataIndex: "plannedInfluentWaterQualitySS",
      width: "4%",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画放流水質 BOD",
      dataIndex: "plannedEffluentWaterQualityBOD",
      width: "3%",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画放流水質 SS",
      dataIndex: "plannedEffluentWaterQualitySS",
      width: "3%",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
  ];

  const initColumn2 = [
    {
      title: "No",
      dataIndex: "No",
      align: "center",
      width: "1%",
      filter: false,
    },
    {
      title: "比較",
      dataIndex: "comparison",
      required: true,
      align: "center",
      render: (_, record) => (
        <Checkbox
          disabled={disabled}
          checked={listSelectBussiness.includes(record.id)}
          onChange={(e) => {
            const value = e.target.checked;
            const overallItem = overallPlanGrid.data.find(
              (i) => i.planningFormulationYear == record.planningFormulationYear
            );

            if (value) {
              setListSelectBussiness([...listSelectBussiness, record.id]);
              if (overallItem) {
                setListSelectOverall([...listSelectOverall, overallItem.id]);
              }
            } else {
              setListSelectBussiness(
                [...listSelectBussiness].filter((i) => i != record.id)
              );
              if (overallItem) {
                setListSelectOverall(
                  [...listSelectOverall].filter((i) => i != overallItem.id)
                );
              }
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      ),
      width: "1%",
    },
    {
      title: "計画策定年度",
      dataIndex: "planningFormulationYear",
      width: "3%",
      align: "center",
    },
    {
      title: "計画目標年度",
      dataIndex: "plannedTargetYear",
      width: "3%",
      align: "center",
    },
    {
      title: "計画汚水量(m3/日)",
      width: "4%",
      dataIndex: "plannedSewageVolume",
      align: "right",
      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画処理能力(m3/日)",
      width: "4%",
      dataIndex: "plannedMaxDailyTreatmentCap",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "処理区域面積 (ha)",
      width: "3%",
      dataIndex: "treatmentAreaSize",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画処理人口",
      dataIndex: "plannedTreatmentPopulation",
      width: "3%",
      align: "right",

      render: renderFormatInput,
    },
    {
      title: "計画流入水質 BOD(mg/l)",
      dataIndex: "plannedInfluentWaterQualityBOD",
      width: "4%",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画流入水質 SS(mg/l)",
      dataIndex: "plannedInfluentWaterQualitySS",
      width: "4%",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画放流水質 BOD",
      dataIndex: "plannedEffluentWaterQualityBOD",
      width: "3%",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
    {
      title: "計画放流水質 SS",
      dataIndex: "plannedEffluentWaterQualitySS",
      width: "3%",
      align: "right",

      render: (value) => renderFormatInputDecimal(value, 3),
    },
  ];
  const [inputValue, setInputValue] = useState("");
  const isPC = useMediaQuery({
    query: "(min-width: 1024px)",
  });
  const [openModalTitle, setOpenModalTitle] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  const [selectedItem2, setSelectedItem2] = useState([]);
  const [isComparisonModalVisible, setComparisonModalVisible] = useState(false);
  const [isComparisonModalVisible2, setComparisonModalVisible2] =
    useState(false);

  const changeInput = (e, item, type = "overall") => {
    const value = e.target ? e.target.value : e;
    if (type === "overall") {
      handlechangeInputPlanOverral(
        item.key,
        value,
        item.rule,
        item.type,
        item.isFormatNumber
      );
      if (item.key === "planningFormulationYear") {
        handlechangeInputPlanBussiness(
          item.key,
          value,
          item.rule,
          item.type,
          item.isFormatNumber
        );
      }
    } else {
      handlechangeInputPlanBussiness(
        item.key,
        value,
        item.rule,
        item.type,
        item.isFormatNumber
      );
    }
  };

  const renderInput = (item, type = "overall") => {
    const isCanEdit =
      type === "overall"
        ? currentOverall && mode === MODE_SCREEN.EDIT
        : currentBussiness && MODE_SCREEN.EDIT;
    if (item.type === INPUT_TYPE.CUSTOM) {
      return item.component;
    }
    if ((mode !== MODE_SCREEN.VIEW && isCanEdit) || mode === MODE_SCREEN.ADD) {
      return (
        <FormInput
          onChange={(e) => {
            const value = e.target.value;
            // if (!REGEX_INPUT.INT_10.test(value)) {
            //   return;
            // }
            changeInput(e, item, type);
          }}
          valueObject={item.value}
          disabled={item.disabled}
          refer={(el) => (inputRefs.current[item.key] = el)}
          haveEmptyOption={item.haveEmptyOption}
          type="number"
          onBlur={(e) => {
            if (item.type === INPUT_TYPE.INPUT && item.isDecimal) {
              const value = e.target.value;
              let finalValue = item.isFormatNumber
                ? String(value).replace(/,/g, "")
                : value;
              finalValue = formatDecimal(Number(finalValue), item.isDecimal);
              changeInput({ target: { value: finalValue } }, item, type);
            }
          }}
          {...item}
        />
      );
    }
    if (item.type === INPUT_TYPE.SWITCH) {
      return item.value.value === true ? lang.YES : lang.NO;
    }
    if (item.type === INPUT_TYPE.SELECT) {
      return item.value.label;
    }
    return item.type === INPUT_TYPE.DATE
      ? item.value.valueString
      : item.value.label || item.value.value;
  };

  const changeTitle = (item) => {
    if (!item.editTitle || mode === MODE_SCREEN.VIEW) {
      return;
    }
    setCurrentItem(item);
    setOpenModalTitle(true);
  };
  const renderDescriptions = (list, type) => {
    return (
      <Descriptions
        className="customEquipmentDes"
        size="small"
        column={1}
        bordered
      >
        {list.map((item, index) => {
          if (
            item.key === "plannedInfluentWaterQualityBOD" ||
            item.key === "plannedInfluentWaterQualitySS" ||
            item.key === "No"
          ) {
            return null;
          }
          if (
            item.key === "plannedEffluentWaterQualityBOD" ||
            item.key === "plannedEffluentWaterQualitySS" ||
            item.key === "No"
          ) {
            return null;
          }
          return (
            <Descriptions.Item
              style={{ width: item.span === 1 ? "30%" : "80%" }}
              key={index}
              labelStyle={{
                width: "6%",
              }}
              label={
                <div
                  onClick={() => changeTitle(item)}
                  style={{
                    cursor: item.editTitle && "pointer",
                    color: item.required ? "red" : undefined,
                  }}
                  className="labelInputEquipment bold"
                >
                  {item.title}
                </div>
              }
              span={item.span || 1}
            >
              {renderInput(item, type)}
            </Descriptions.Item>
          );
        })}
        <Descriptions.Item
          style={{ width: "20%" }}
          label={
            <div className="labelInputEquipment bold">計画流入水質(mg/L)</div>
          }
          span={1}
        >
          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item
              style={{ width: "20%" }}
              labelStyle={{
                width: "6%",
              }}
              label={<div className="bold">BOD</div>}
            >
              {renderInput(
                list.find(
                  (item) => item.key === "plannedInfluentWaterQualityBOD"
                ),
                type
              )}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ width: "20%" }}
              labelStyle={{
                width: "6%",
              }}
              label={<div className="bold">SS</div>}
            >
              {renderInput(
                list.find(
                  (item) => item.key === "plannedInfluentWaterQualitySS"
                ),
                type
              )}
            </Descriptions.Item>
          </Descriptions>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <div className="labelInputEquipment bold">計画放流水質(mg/L)</div>
          }
        >
          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item
              style={{ width: "20%" }}
              labelStyle={{
                width: "6%",
              }}
              label={<div className="bold">BOD</div>}
            >
              {renderInput(
                list.find(
                  (item) => item.key === "plannedEffluentWaterQualityBOD"
                ),
                type
              )}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ width: "20%" }}
              labelStyle={{
                width: "6%",
              }}
              label={<div className="bold">SS</div>}
            >
              {renderInput(
                list.find(
                  (item) => item.key === "plannedEffluentWaterQualitySS"
                ),
                type
              )}
            </Descriptions.Item>
          </Descriptions>
        </Descriptions.Item>
      </Descriptions>
    );
  };
  const renderDescriptionPopUP = (items, a) => {
    if (!items || items.length === 0) return null;

    return (
      <div>
        <h1 style={{ color: "black", fontSize: "26px", fontWeight: "bold" }}>
          {a === false ? "全体計画" : "事業計画"}
        </h1>
        <div style={{ display: "flex", gap: "12px", width: "100%" }}>
          <div style={{ flex: 1 }}>
            {items[0] && (
              <h1
                style={{
                  color: "black",
                  fontSize: "22px",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                計画値情報 1
              </h1>
            )}
          </div>
          <div style={{ flex: 1 }}>
            {items[1] && (
              <h1
                style={{
                  color: "black",
                  fontSize: "22px",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                計画値情報 2
              </h1>
            )}
          </div>
        </div>
        <Descriptions size="small" column={2} bordered>
          {items.map((item, index) => (
            <Descriptions.Item
              key={`item-${index}`}
              label={`計画策定年度`}
              labelStyle={{
                width: "20%",
              }}
            >
              {item.planningFormulationYear}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedTargetYear-${index}`}
              label={`計画目標年度`}
              labelStyle={{
                width: "20%",
              }}
            >
              {item.plannedTargetYear}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedSewageVolume-${index}`}
              label={`計画汚水量 (m3/日)`}
              labelStyle={{
                width: "20%",
              }}
            >
              {item.plannedSewageVolume}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedMaxDailyTreatmentCap-${index}`}
              label={`計画処理能力日最大(m3/日)`}
              labelStyle={{
                width: "20%",
              }}
            >
              {item.plannedMaxDailyTreatmentCap}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`treatmentAreaSize-${index}`}
              label={`処理区域面積 (ha)`}
              labelStyle={{
                width: "20%",
              }}
            >
              {item.treatmentAreaSize}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedTreatmentPopulation-${index}`}
              label={`計画処理人口`}
              labelStyle={{
                width: "6%",
              }}
            >
              {item.plannedTreatmentPopulation}
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedInfluent-${index}`}
              label={`計画流入水質(mg/l)`}
              labelStyle={{
                width: "6%",
              }}
            >
              <Descriptions size="small" column={1} bordered>
                <Descriptions.Item
                  key={`plannedInfluentWaterQualityBOD-${index}`}
                  label={<div className="bold">BOD</div>}
                  style={{ width: "20%" }}
                  labelStyle={{
                    width: "6%",
                  }}
                >
                  {item.plannedInfluentWaterQualityBOD}
                </Descriptions.Item>
                <Descriptions.Item
                  key={`plannedInfluentWaterQualitySS-${index}`}
                  label={<div className="bold">SS</div>}
                  style={{ width: "20%" }}
                  labelStyle={{
                    width: "6%",
                  }}
                >
                  {item.plannedInfluentWaterQualitySS}
                </Descriptions.Item>
              </Descriptions>
            </Descriptions.Item>
          ))}
          {items.map((item, index) => (
            <Descriptions.Item
              key={`plannedEffluent-${index}`}
              label={`計画放流水質`}
            >
              <Descriptions size="small" column={1} bordered>
                <Descriptions.Item
                  key={`plannedEffluentWaterQualityBOD-${index}`}
                  label={<div className="bold">BOD</div>}
                  style={{ width: "20%" }}
                  labelStyle={{
                    width: "6%",
                  }}
                >
                  {item.plannedEffluentWaterQualityBOD}
                </Descriptions.Item>
                <Descriptions.Item
                  key={`plannedEffluentWaterQualitySS-${index}`}
                  label={<div className="bold">SS</div>}
                  labelStyle={{
                    width: "6%",
                  }}
                  style={{ width: "20%" }}
                >
                  {item.plannedEffluentWaterQualitySS}
                </Descriptions.Item>
              </Descriptions>
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
    );
  };
  const dataWithNo = (data = []) =>
    data.map((item, index) => ({ ...item, No: index + 1 }));
  return (
    <Row gutter={16}>
      <Modal
        className="modal"
        title={
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#0080cb",
              color: "white",
              padding: "6px",
              fontSize: "28px",
              borderBottom: "none",
              marginBottom: 0,
            }}
          >
            比較結果
          </div>
        }
        width={1200}
        visible={isComparisonModalVisible}
        onCancel={() => setComparisonModalVisible(false)}
        closable={false}
        footer={[
          <Button
            onClick={() => setComparisonModalVisible(false)}
            className="buttonPC --todo-- wAuto  button--outline"
          >
            <CloseCircleOutlined />
            {lang.CLOSE}
          </Button>,
        ]}
      >
        {renderDescriptionPopUP(selectedItems, false)}
      </Modal>
      <Modal
        title={
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#0080cb",
              color: "white",
              padding: "10px",
              fontSize: "32px",
            }}
          >
            比較結果
          </div>
        }
        width={1200}
        visible={isComparisonModalVisible2}
        onCancel={() => setComparisonModalVisible2(false)}
        closable={false}
        footer={[
          <Button
            onClick={() => setComparisonModalVisible2(false)}
            className="buttonPC --todo-- wAuto  button--outline"
          >
            <CloseCircleOutlined />
            {lang.CLOSE}
          </Button>,
        ]}
      >
        {renderDescriptionPopUP(selectedItem2, true)}
      </Modal>

      <Col span={12}>
        <Row align="middle" gutter={[5, 5]} style={{ marginBottom: "5px" }}>
          <Col>
            <span
              className="bold"
              style={{ fontSize: "20px", marginRight: "22px" }}
            >
              全体計画
            </span>
          </Col>
        </Row>
        <Table
          color={"#fff"}
          className="table-selected-custom table-equipment-custome"
          style={{ marginBottom: "25px" }}
          rowKey={(record) => record.id}
          dataSource={dataWithNo(overallPlanGrid.data)}
          pagination={false}
          scroll={{ x: 2200, y: 400 }}
          columns={initColumns}
          onRow={(record) => ({
            onClick: () => {
              if (disabled) {
                return;
              }
              onSelectData(record, 1);
            },
          })}
          rowClassName={(record) =>
            currentOverall && record.id == currentOverall.id
              ? "selected-row-facilityMaster"
              : ""
          }
        />
        {renderDescriptions(listViewOverrall, "overall")}
      </Col>
      <Col span={12}>
        <Row align="middle" gutter={[5, 5]} style={{ marginBottom: "5px" }}>
          <Col>
            <span
              className="bold"
              style={{ fontSize: "20px", marginRight: "22px" }}
            >
              事業計画
            </span>
          </Col>
        </Row>
        <Table
          rowClassName={(record) =>
            currentBussiness && record.id == currentBussiness.id
              ? "selected-row-facilityMaster"
              : ""
          }
          color={"#fff"}
          className="table-selected-custom table-equipment-custome"
          style={{ marginBottom: "25px" }}
          rowKey={(record) => record.id}
          pagination={false}
          scroll={{ x: 2200, y: 400 }}
          dataSource={dataWithNo(bussinessPlanGrid.data)}
          columns={initColumn2}
          onRow={(record) => ({
            onClick: () => {
              if (disabled) {
                return;
              }
              onSelectData(record, 2);
            },
          })}
        />
        {renderDescriptions(listViewBussiness, "bussiness")}
      </Col>
    </Row>
  );
}

export default PlanValudeInformation;
